import script from "./AnimatedNumber.vue?vue&type=script&setup=true&lang=js"
export * from "./AnimatedNumber.vue?vue&type=script&setup=true&lang=js"

import "./AnimatedNumber.vue?vue&type=style&index=0&id=5e039722&lang=sass&scoped=true"

import exportComponent from "/Users/yablonev/Desktop/Yablonev/Coding/GitHub/TON/Highload-UI/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e039722"]])

export default __exports__